<template>
  <div>
      <!-- MODAL CADASTRO DE USUARIO -->
      <ModalRegras :id="selectedId" :visible="visibleModalRegra" />

      <container-card fixed id="cadastroDeRegraAcesso" icon="el-icon-user" title="Regras de acesso cadastradas">
           <!-- btn-cadastrar novo usuario e modal -->
          <div id="criarNovoRegraAcesso" @click="novoRegraAcesso" class="add-button"  
              v-b-popover.hover.top="'Adicionar novo Usuário.'">
              <i class="fas fa-plus"></i>
          </div>
          <b-card>
              <el-table
                  class="p-table"
                  v-loading="tableOptions.load"
                  :data="tableOptions.dataTemp"
                  style="width: 100%"
                  stripe
                  border
                  size="mini">
                  
                  <el-table-column prop="nome" label="Nome" align="left">
                      <template slot="header" slot-scope="scope">
                          Regra de acesso
                          <el-popover
                          ref="filterNome"
                          placement="bottom"
                          trigger="click"
                          width="400">
                              <div>
                                  <el-input class="input-filter" placeholder="Pesquisar nome" v-model="model.nome" size="mini"></el-input>
                              </div>
                              <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                              <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter('nome')">Limpar</el-button>
                              <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                          </el-popover>
                      </template>
                  </el-table-column>

                  <el-table-column
                      label="Tipo"
                      width="130"
                      align="center">
                      <template slot-scope="scope" v-if="scope.row">
                          <el-tooltip class="item" effect="dark" :content="isAdmin(scope.row.acessos) ? 'Administrador':'Usuário comum'" placement="top">
                          <i v-if="isAdmin(scope.row.acessos)" class="el-tooltip fas fa-circle text-success item" tabindex="0"></i>
                          <i v-else class="el-tooltip fas fa-circle  item" tabindex="0"></i>
                          </el-tooltip>
                      </template>
                  </el-table-column>

                  <el-table-column
                      fixed="right"
                      label="Operações"
                      width="130"
                      align="center">
                      <template slot-scope="scope" v-if="scope.row">
                          <el-button title="Editar Regra" class="mr-1 cursor-pointer" icon="el-icon-edit-outline" circle size="mini" type="primary" @click.native="editarRegraAcesso(scope.row)"></el-button>
                          <el-popover
                              placement="top"
                              width="250"
                              :ref="`deletePop_${scope.$index}`">
                              <p>Tem certeza que deseja deletar esse registro ?</p>
                              <div style="text-align: right; margin: 0">
                                  <el-button type="secundary" size="mini" @click="deletarRegraAcessoOptOut(scope.$index)">Não</el-button>
                                  <el-button type="danger" size="mini" @click.native="deleteRegraAcesso(scope.$index, scope.row)">Sim</el-button>
                              </div>
                              <el-button title="Deletar Usuário" class="cursor-pointer" slot="reference" icon="el-icon-delete" circle size="mini" type="danger"></el-button>
                          </el-popover>
                      </template>
                  </el-table-column>
              </el-table> <br>
          </b-card>
      </container-card>
    </div>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import ModalRegras from './modal/ModalRegras'

export default {
  name: 'RegraAcessos',
  components: {
      ContainerCard,
      ModalRegras,
  },
  props: {

  },
  data() {
      return {
          windowHeight: window.innerHeight,
          visibleModalRegra: false,
          selectedId: '',
          model: {
              nome: ''
          },
          tableOptions: {
              load: false,
              data: [],
              dataTemp: []
          }
      }
  },
  computed: {
      tableHeight() {
          return this.windowHeight - 277
      },
      regraAcesso() {
          return !this.premiumUser() && this.totalDeUsers >= 3
      }
  },
  methods: {
      isAdmin(acessos) {
          return !!(acessos.find(r => r.name === 'sysAdmin'));
      },
      setFilter() {
          this.tableOptions.dataTemp = this.tableOptions.data.filter(data => !this.model.nome || data.nome.toLowerCase().includes(this.model.nome.toLowerCase()))
      },
      clearFilter(name) {
          this.model[name] = ''
          this.tableOptions.dataTemp = this.tableOptions.data
      },
      novoRegraAcesso() {
          this.selectedId = '';
          this.$bvModal.show('modal-regra-usuario')
      },
      editarRegraAcesso(row) {
          this.selectedId = row._id;
          this.$bvModal.show('modal-regra-usuario')
      },
      deletarRegraAcessoOptOut(index, label, grupo) {
          if (grupo) {
              this.$refs['deletePop_grupo_' + index][0].showPopper = false
              return false
          }
          if (label) {
              this.$refs['deletePop_' + (label ? label : '') + index][0].showPopper = false
              return false
          }

          this.$refs['deletePop_' + (label ? label : '') + index].showPopper = false

      },
      async deleteRegraAcesso(index, row) {
          let response = await this.axios.delete(this.$urls.EXCLUIR_UMA_REGRA, {
              params: {
                  id: row._id
              }
          });

          if (response.status !== 200) {
              return;
          }

          this.$message({
              type: 'success',
              message: 'Usuário deletado com sucesso !'
          });

          this.listarRegraAcessos();
          this.$refs['deletePop_' + index].showPopper = false
      },
      async listarRegraAcessos() {
          try {
              this.tableOptions.load = true
              const response = await this.axios.get(this.$urls.LISTAR_REGRAS_DE_ACESSOS);

              if (response.status !== 200) {
                  this.$notify.error({
                      title: 'Listar regras',
                      message: `Não foi possível obter a lista de regras`,
                      position: 'top-left'
                  });
                  return
              }
              this.tableOptions.data = response.data;
              this.tableOptions.dataTemp = response.data;

          } catch (err) {
              this.$notify.error({
                  title: 'Erro interno',
                  message: err.response ? err.response.data : `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                  position: 'top-left'
              });
          } finally {
              this.tableOptions.load = false
          }
      }
  },
  mounted() {
      window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
      });

      this.listarRegraAcessos();
  }
};
</script>
<style lang='scss' scoped>
  .input-filter {
    margin-bottom: 5px;
  }
     .add-button{
         width: 51px;
         padding: 14px 0;
         background: #343a40;
         color: #fff;
         text-align: center;
         border-radius: 50%;
         position: fixed;
         z-index: 10;
         cursor: pointer;
         bottom: 6px;
         margin-left: 3px;
     }
  </style>
<style lang="scss">
  .usuario-screen {
    .el-table__fixed-right-patch {
      width: 0 !important;
    }
  }
  </style>